import { graphql } from "../generated/gql";

export const GetTemplatesGQL = graphql(`
  query getTemplates {
    templates {
      items {
        id
        name
      }
    }
  }
`);
